import { LocalStorageService } from '../local-storage/local-storage.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ControlStateSaveService {

  constructor(
    private localStorageService: LocalStorageService
  ) { }

  setControlState(stateName, value) {
    this.localStorageService.setItem(stateName, JSON.stringify(value));
  }

  getControlState(stateName) {
    return JSON.parse(this.localStorageService.getItem(stateName));
  }

  removeControlState(stateName) {
    localStorage.removeItem(stateName);
  }
}
